import React, {useEffect, useState} from "react";
import { useLocalStorageNew } from "../../../hooks/useLocalStorageNew";
import {
    ACCESS,
    COMPLETED_CONNECT,
    COMPLETED_STEP,
    CONNECT_BTN,
    CONNECT_STEP,
    CONNECT_SUBTITLE,
    EXT_CONNECTION_ERROR,
    GET_CHROME_EXT_MESSAGE,
    INSTALL_BTN,
    INSTALL_STEP,
    INSTALL_SUBTITLE,
    INTEGRATED_PRODUCTS,
    INTEG_SUBTITLE,
    LOGOUT_CHROME_EXT_MESSAGE,
    MENTIMETER,
    MENTIMETER_EXTENSION_ID,
    MENTIMETER_STEPS,
    MIGRATE_QUES,
    PE_STEPS,
    POLL_EVERYWHERE,
    POLL_EVERYWHERE_EXTENSION_ID,
    SESSION,
    TOPHAT,
    TOPHAT_EXTENSION_ID,
    TOPHAT_STEPS,
} from "../../../utils/constants";
import styles from "./CrossIntegration.module.css";
import YuJaButton from "../../../components/standardization/YuJaButton";
import {YuJaDropdown} from "../../../components/standardization/YuJaDropdown";
import {ReactComponent as Checkmark} from "../../../images/ext_integration_checkmark.svg";
import THExt from "../../../images/tophat.svg";
import MExt from "../../../images/mentimeter.svg";
import PEExt from "../../../images/polleverywhere.svg";
import Extension from "../../../images/extension.svg";
import {isChromiumBrowser, notifyError, sendMsgToExtension} from "../../../utils/helpers";
import {useConfig} from "../../../hooks/useConfig";

export default function CrossIntegration() {
    const [hasConnection, setHasConnection] = useState(false);
    const [extInstalled, setExtInstalled] = useState(false);
    const [, getSession] = useLocalStorageNew(SESSION, {});
    const [currPlatform, setCurrPlatform] = useState(MENTIMETER);
    const session = getSession();
    let config = useConfig();
    
    const getStepTitle = () => {
        return ACCESS + currPlatform + MIGRATE_QUES;
    };

    const getExtUrl = () => {
        if(currPlatform === TOPHAT) {
            return config.migration_chrome_extension.top_hat;
        }
        else if(currPlatform === MENTIMETER) {
            return config.migration_chrome_extension.mentimeter;
        }
        else if(currPlatform === POLL_EVERYWHERE) {
            return config.migration_chrome_extension.poll_everywhere;
        }
    };

    const getExtSupport = () => {
        if(currPlatform === TOPHAT) {
            return config.migration_chrome_extension.top_hat_support_url;
        }
        else if(currPlatform === MENTIMETER) {
            return config.migration_chrome_extension.mentimeter_support_url;
        }
        else if(currPlatform === POLL_EVERYWHERE) {
            return config.migration_chrome_extension.poll_everywhere_support_url;
        }
    };
    
    const getPlatformSteps = () => {
        if(currPlatform === TOPHAT) {
            return TOPHAT_STEPS
        }
        else if(currPlatform === MENTIMETER) {
            return MENTIMETER_STEPS
        }
        else if(currPlatform === POLL_EVERYWHERE) {
            return PE_STEPS;
        }
    };

    const getPlatformImage = () => {
        if(currPlatform === TOPHAT) {
            return THExt;
        }
        else if(currPlatform === MENTIMETER) {
            return MExt;
        }
        else if(currPlatform === POLL_EVERYWHERE) {
            return PEExt;
        }
    };
    
    const steps = [
        {
            title: INSTALL_STEP,
            subtitle: INSTALL_SUBTITLE,
            button: INSTALL_BTN,
            completed: COMPLETED_STEP,
            img: Extension
        }, 
        {
            title: CONNECT_STEP,
            subtitle: CONNECT_SUBTITLE,
            button: CONNECT_BTN,
            completed: COMPLETED_CONNECT,
            img: Extension
        }, 
        {
            title: getStepTitle(),
            substeps: getPlatformSteps(),
            img: getPlatformImage()
        }
    ];

    const getExtensionId = () => {
        if(currPlatform === TOPHAT) {
            return TOPHAT_EXTENSION_ID;
        }
        else if(currPlatform === MENTIMETER) {
            return MENTIMETER_EXTENSION_ID;
        }
        else if(currPlatform === POLL_EVERYWHERE) {
            return POLL_EVERYWHERE_EXTENSION_ID;
        }
    };

    useEffect(() => {
        // 1. Get authorization token and userId from chrome extension
        try {
            if (!window.chrome.runtime) {
                return;
            }

            sendMsgToExtension(getExtensionId(), {info: GET_CHROME_EXT_MESSAGE}).then(response => {
                if(response) {
                    setExtInstalled(true);
                    if(response.authToken !== session.authorization
                        || response.userId !== session.userId
                        || response.api !== config.api.poll
                    ) {
                        sendMsgToExtension(getExtensionId(), {info: LOGOUT_CHROME_EXT_MESSAGE});
                        setHasConnection(false);
                    }
                    else {
                        setHasConnection(true);
                    }

                } else {
                    setHasConnection(false);
                    setExtInstalled(false);
                }
            })

            // window.chrome.runtime.sendMessage(getExtensionId(), {info: GET_CHROME_EXT_MESSAGE}, function(response) {
            //     // 2. If no response, or authorization token is invalid - ask user to connect again
            //     if(response) {
            //         setExtInstalled(true);
            //         if(response.authToken !== session.authorization || response.userId !== session.userId) {
            //             window.chrome.runtime.sendMessage(getExtensionId(), {logout: LOGOUT_CHROME_EXT_MESSAGE}, function(response) {})
            //             setHasConnection(false);
            //         }
            //         else {
            //             setHasConnection(true);
            //         }
            //
            //     } else {
            //         setHasConnection(false);
            //         setExtInstalled(false);
            //     }
            // })
        }
        catch(e) {
            setHasConnection(false);
            setExtInstalled(false);
        }
    }, [currPlatform]);
    
    const sendConnection = () => {
        if (!window.chrome.runtime) {
            notifyError(EXT_CONNECTION_ERROR);
            return;
        }


        let sessionCopy = JSON.parse(JSON.stringify(session));
        if (currPlatform === TOPHAT) {
            sessionCopy.api = `${config.api.poll}/poll/tophat`;
        } else if (currPlatform === MENTIMETER) {
            sessionCopy.api = `${config.api.poll}/poll/mentimeter`;
        } else if (currPlatform === POLL_EVERYWHERE) {
            sessionCopy.api = `${config.api.poll}/poll/polleverywhere`;
        }

        sendMsgToExtension(getExtensionId(), {session: sessionCopy}).then(response => {
            if(response && response.authToken && response.userId && response.authToken === session.authorization && response.userId === session.userId) {
                setHasConnection(true);
                setExtInstalled(true);
            } else {
                setHasConnection(false);
                notifyError(EXT_CONNECTION_ERROR);
            }
        });

        // window.chrome.runtime.sendMessage(getExtensionId(), {session: session}, function(response) {
        //     if(response && response.authToken && response.userId && response.authToken === session.authorization && response.userId === session.userId) {
        //         setHasConnection(true);
        //         setExtInstalled(true);
        //     } else {
        //         setHasConnection(false);
        //         notifyError(EXT_CONNECTION_ERROR);
        //     }
        // });
    };
    
    const stepCompleted = (index) => {
        if(index === 0 && isChromiumBrowser() && extInstalled) {
            return true;
        }
        else if (index === 1 && hasConnection) {
            return true;
        }
        else {
            return false;
        }
    };

    return (
        <div style={{display: "flex", flexDirection: "column", width: "100%", height: "100%", alignItems: "center"}}>
            <div style={{maxWidth: 1200, display: "flex", flexDirection: "column",}}>
                <div style={{marginTop: "10px"}}>{INTEG_SUBTITLE}</div>
                <div style={{display: "flex", alignItems: "center", marginBottom: "30px", marginTop: "20px"}}>
                    Select Product
                    <YuJaDropdown containerStyle={{width: "370px", marginLeft: "20px"}} value={currPlatform}
                                  data={INTEGRATED_PRODUCTS} onChange={(item) => {
                        setCurrPlatform(item.value)
                    }}></YuJaDropdown>
                </div>
                {steps.map((step, index) => {
                    return (<>
                        {!stepCompleted(index) &&
                            <div className={styles.containerStep} key={index}>
                                <div style={{display: "flex", alignItems: "center"}}>
                                    <div className={styles.stepNo}>{index + 1}</div>
                                    <div style={{marginLeft: "15px", fontWeight: "700"}}>{step.title}</div>
                                    <div className={styles.line}></div>
                                </div>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    height: "100%"
                                }}>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        flexDirection: "column",
                                        paddingTop: "10px",
                                        height: "100%",
                                        gap: 10
                                    }}>
                                        {step.subtitle && <div >{step.subtitle}</div>}
                                        {step.button && step.button === "Install Extension" &&
                                            <YuJaButton
                                                onClick={() => window.open(getExtUrl())}>{step.button}</YuJaButton>
                                        }
                                        {step.button && step.button === "Connect" &&
                                            <YuJaButton onClick={sendConnection}>{step.button}</YuJaButton>
                                        }
                                        {step.substeps && step.substeps.map((substep) => {
                                            return <div key={substep}>{substep}</div>
                                        })
                                        }
                                    </div>
                                    <div>
                                        <img src={step.img}
                                             className={index === 2 ? styles.extImage : styles.defaultImg}
                                             alt={"Chrome Extension Image Step " + index}/>
                                        {index === 0 &&
                                            <div>Not sure how to install the plugin? <a href={getExtSupport()}
                                                                                        target="_blank">Click here</a>.
                                            </div>}
                                    </div>
                                </div>
                            </div>}
                        {stepCompleted(index) && <div className={styles.completedContainer} key={index}>
                            <div>{step.completed}</div>
                            <Checkmark/>
                        </div>}
                    </>)
                })}

            </div>
        </div>

    );
};
